//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  created(){
    
  },
  data: () => ({
    tabt:1,
    loading: false,
    finished: false,
    list: [],
    form:{
      title:'',
      pageIndex:1,
      pageSize:10
    },
    userType:''
  }),
  methods: {
    // 切换状态
    changeTab(index){
      this.tabt = index
      this.form.couponStatus=index
      this.form.pageIndex=1
      this.list=[]
      this.getList()
    },
    // 优惠券列表
     getList() {
      this.loading = true;
      this.$get("/pay/user/coupon/list", this.form, function (res) {
        var newArr = res.data.records;
        if (!newArr || newArr.length === 0) {
          this.finished = true;
        } else {
          for(var i=0;i<newArr.length;i++){
            newArr[i].show=0
          }
          this.list.push(...newArr);
          this.form.pageIndex = this.form.pageIndex + 1;
        }
        this.loading = false;
      });
    },
  },
  mounted() {
   
  },
};
